<script setup lang="ts">
import { computed, ref, watch } from "vue";

const emits = defineEmits(["update:modelValue", "entered"]);
const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  onlyNumeric: {
    type: Boolean,
    default: false,
  },
});

const digits = ref(Array(6).fill(""));
const allDigitsFilled = computed(() => digits.value.every((digit) => digit !== ""));
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue.length === digits.value.length) {
      for (let i = 0; i < digits.value.length; i++) {
        digits.value[i] = newValue[i];
      }
    }
  },
  { immediate: true }
);

const onInput = (index: number) => {
  
  console.log("handleInput");
  if (index < digits.value.length - 1) {
    const currentInput = document.querySelectorAll(".digit-box")[index];
    const nextInput = document.querySelectorAll(".digit-box")[index + 1];
    if (currentInput instanceof HTMLInputElement && nextInput instanceof HTMLElement) {
      if (currentInput.value !== "" && nextInput) {
        nextInput.focus();
      }
    }
  }
  emitValue();
  if (digits.value.every((digit) => digit !== "")) {
    if (index === digits.value.length - 1) {
      const currentInput = document.querySelectorAll(".digit-box")[index];
      if (currentInput instanceof HTMLInputElement) {
        if (currentInput) {
          currentInput.blur();
        }
      }
    }

    if (index === digits.value.length - 1 && allDigitsFilled.value) {
      emits("entered");
    }
  }
};

const handlePaste = (event) => {
  event.preventDefault();
  console.log("handlePaste");
  const pasteData = event.clipboardData ? event.clipboardData.getData("text") : "";
  if (pasteData.length === digits.value.length && pasteData !== digits.value.join("")) {
    for (let i = 0; i < digits.value.length; i++) {
      digits.value[i] = pasteData[i];
    }
    event.clipboardData.clearData();
    emitValue();
    if (allDigitsFilled.value) {
      emits("entered");
    }
  }
};

const setFocus = (index: number) => {
  if (index >= 0 || index < digits.value.length) {
    const input = document.querySelectorAll(".digit-box")[index] as HTMLInputElement;
    if (input) {
      input.focus();
      const inputType = input.type;
      input.type = "text"; // Temporarily change to text
      input.setSelectionRange(0, 1); // Set selection range
      input.type = inputType; // Change back to number
    }
  }
}

const handleKeydown = (index: number, event: KeyboardEvent) => {
  if (event.key === "Backspace" && digits.value[index] === "") {
    if (index > 0) {
      const previousInput = document.querySelectorAll(".digit-box")[index - 1] as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
      digits.value[index - 1] = "";
      emitValue();
    }
  }
};

const emitValue = () => {
  emits("update:modelValue", digits.value.join(""));
};

const handleInputFocus = ($event: FocusEvent) => {
  // select all text in the input 
  $event.target.select();
};
</script>

<template>
  <div ref="otpCont" class="otp-container">
    <template v-for="(digit, index) in digits" :key="`digit-box${index}`">
      <div class="digit-box-container" :class="{
        'digit-box-left': index === 0 || index === 3,
        'digit-box-right': index === 2 || index === 5
      }">
        <input v-if="onlyNumeric || index > 2" type="number" class="digit-box" v-model="digits[index]"
          @keyup.right="setFocus(index + 1)" @keyup.left="setFocus(index - 1)" @keydown="handleKeydown(index, $event)"
          @input="onInput(index)" @focus="handleInputFocus" maxlength="1" @paste="handlePaste" @change="handlePaste"
          autofocus />

        <input v-else type="text" class="digit-box" @keyup.right="setFocus(index + 1)" @keyup.left="setFocus(index - 1)"
          v-model="digits[index]" @keydown="handleKeydown(index, $event)" @input="onInput(index)" maxlength="1"
          @paste="handlePaste" @change="handlePaste" autofocus />

      </div>
      <div v-if="index === 2" class="digit-box-container digit-box-dash">
        <span class="icon text-contrast">
          <i class="fas fa-minus"></i>
        </span>
      </div>
    </template>
  </div>
</template>

<style scoped>
.otp-container {
  display: flex;
  justify-content: center;
  gap: 0;
  height: 78px;
}

.digit-box-left {
  border-radius: 5px 0 0 5px;
  border-color: lightgray;
}

.digit-box-right {
  border-radius: 0 5px 5px 0;
  border-width: 1px 1px 1px 1px !important;
}

.digit-box-container {
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: lightgray;
  padding: 15px 0;


}

.digit-box {
  box-shadow: none;
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  border-radius: 0;
  border-width: 0;
  border-color: lightgray;


  box-shadow: none !important;
  /* Remove any shadow */
  outline: none;
  /* Remove outline */
  appearance: none;
  /* Remove default styling */

}

.digit-box-dash {
  vertical-align: middle;
  text-align: center;
  width: 40px;
  border-width: 0 !important;
  padding-top: 25px;
}
</style>